export const TRIAL_PAGES_V1B = 'v1b';
